import empower from "@/views/empower/empower";
export default empower;
